import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PostHogProvider } from "posthog-js/react";
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const options = {
  api_host: "https://us.i.posthog.com",
};

const apiKey = "phc_QPqimGKSqhTAP36cIUTDsOnWrKWuOrwCQrvHAOml8C3";

root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={apiKey} options={options}>
      <App />
      <Analytics />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
